export const setFinalState = (finalState) => ({
  type: 'SET_FINAL_STATE',
  payload: finalState,
});